import { render } from "./ReportGrid.vue?vue&type=template&id=65365365"
import script from "./ReportGrid.vue?vue&type=script&lang=js"
export * from "./ReportGrid.vue?vue&type=script&lang=js"

import "./ReportGrid.vue?vue&type=style&index=0&id=65365365&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__